/**
 * Работа с ФИО. Вынесено из Avatar.tsx: файл, экспортирующий и компоненты,
 * и функции, ломает fast refresh в разработке.
 */

export interface PersonName {
  firstName: string;
  lastName: string;
  middleName?: string | null;
}

/**
 * Инициалы из фамилии и имени, а не из первых двух слов ФИО:
 * «Ковалёва Анна Петровна» даёт КА, а не КП.
 */
export function initialsOf(person: PersonName): string {
  const last = person.lastName.trim().charAt(0);
  const first = person.firstName.trim().charAt(0);
  return `${last}${first}`.toUpperCase();
}

/** ФИО в едином порядке — §5.1 требует единообразия формирования. */
export function fullNameOf(person: PersonName): string {
  return [person.lastName, person.firstName, person.middleName]
    .filter((part): part is string => typeof part === "string" && part.trim().length > 0)
    .join(" ");
}
